import React, { useState } from 'react';
import { Box, Typography, Paper, useTheme, List, Divider } from '@mui/material';
import { Sidebar } from '../components/Sidebar';
import { ChatInput } from '../components/ChatInput';     
import { ChatMessage } from '../components/ChatMessage'; 

// Mock data for chat rooms to make the title dynamic
const roomData = {
    1: "Mental Health Support",
    2: "Housing & Rent Assistance",
    3: "Job Search & Skills"
};

// Initial messages for the default room (Room 1)
const initialMessages = [
  { id: 1, text: "Welcome to the Mental Health Support room! Remember to be kind and supportive.", senderId: "admin", timestamp: "10:00 AM", isCurrentUser: false },
  { id: 2, text: "Has anyone found good resources for managing stress related to job searching?", senderId: "user-A", timestamp: "10:05 AM", isCurrentUser: false },
  { id: 3, text: "Yes, I can share a link I found helpful. It’s about building a structured routine. It helped me feel grounded.", senderId: "current-user", timestamp: "10:07 AM", isCurrentUser: true }
];

export const ChatRoom = () => {
    const theme = useTheme();
    const [activeRoom, setActiveRoom] = useState(1); 
    const [messages, setMessages] = useState(initialMessages);

    // Get the title of the active room
    const activeRoomTitle = roomData[activeRoom] || "Community Chat";

    const handleSelectRoom = (roomId) => {
        setActiveRoom(roomId);
        // NOTE: In a real application, you would fetch new messages here based on roomId
        setMessages([
            { id: Date.now(), text: `You have switched to the ${roomData[roomId]} room.`, senderId: "system", timestamp: new Date().toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' }), isCurrentUser: false, isSystem: true }
        ]);
    };
    
    const handleCreateChat = () => {
        console.log("Redirecting to Create Chat Page...");
        // In a real app, you would use: navigate('/create-chat')
    };
    
    const handleSendMessage = (text) => {
        if (!text.trim()) return; // Don't send empty messages

        const newMessage = {
            id: Date.now(),
            text: text,
            senderId: "current-user",
            timestamp: new Date().toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' }),
            isCurrentUser: true
        };
        setMessages(prev => [...prev, newMessage]);
    };

    return (
        <Box 
            sx={{ 
                display: 'flex', 
                // Adjust height to account for the globally rendered Header (64px)
                minHeight: 'calc(100vh - 64px)' 
            }}
        >
            {/* 1. Sidebar (Fixed Width, Room List) */}
            <Sidebar 
                onSelectRoom={handleSelectRoom} 
                onCreateChat={handleCreateChat} 
            />
            
            {/* 2. Main Chat Window Area (Flexible Width) */}
            <Box sx={{ flexGrow: 1, p: 3, bgcolor: theme.palette.background.default }}>
                <Paper 
                    elevation={2} 
                    sx={{ 
                        height: '100%', 
                        p: 2, 
                        display: 'flex', 
                        flexDirection: 'column',
                        borderRadius: 3
                    }}
                >
                    {/* Chat Header (Dynamic Room Title) */}
                    <Typography variant="h5" sx={{ fontWeight: 700, mb: 1.5, color: theme.palette.primary.main }}>
                        Community: {activeRoomTitle}
                    </Typography>
                    <Divider sx={{ mb: 2 }}/>
                    
                    {/* Message Display Area */}
                    <Box 
                        sx={{ 
                            flexGrow: 1, 
                            overflowY: 'auto', 
                            px: 1,
                        }}
                    >
                        <List disablePadding>
                            {messages.map((msg) => (
                                <ChatMessage key={msg.id} message={msg} isCurrentUser={msg.isCurrentUser} />
                            ))}
                        </List>
                    </Box>

                    {/* Chat Input */}
                    <ChatInput onSendMessage={handleSendMessage} />
                    
                </Paper>
            </Box>
        </Box>
    );
};